import { CollectionConfig, CollectionSlug, CollectionAfterChangeHook, PayloadRequest } from 'payload';
import { NotifiableOptions, NotifyProps } from '@components/(payload)/edit/save-and-notify'
import { isObject, mergeObjects } from '@utils/objects';

export type { NotifyProps } from '@components/(payload)/edit/save-and-notify'

// Make a Collection Notifiable
export const enableNotification = (collection: CollectionConfig, options: NotifyProps): CollectionConfig => {
  collection.admin = collection.admin || {};
  collection.hooks = collection.hooks || {};

  const defaultOptions: Partial<NotifiableOptions> = {
    button: {},
    isImportant: false,
  };

  const notificableOptions: NotifiableOptions = isObject(options.notifiable) ? mergeObjects(defaultOptions, options.notifiable) : defaultOptions;

  // Add component if not added
  if (! collection.admin?.components?.edit?.SaveButton) {
    collection.admin.components = collection.admin.components || {};
    collection.admin.components.edit = collection.admin.components.edit || {};
    collection.admin.components.edit.SaveButton = {
      path: '@components/(payload)/edit/save-and-notify',
      clientProps: notificableOptions.button,
    };
  }

  // Add hooks
  const hook: CollectionAfterChangeHook = async (args) => {
    const { req } = args;

    if (! req?.data || ! req.data?.sendNotification) {
      return;
    }

    const notification = await notificableOptions.notification(args);

    if (! notification) {
      return;
    }

    await req.payload.jobs.queue({ queue: 'minutely', task: 'send-notifications', input: { notification, is_important: notificableOptions.isImportant } });
  }

  collection.hooks.afterChange = collection.hooks.afterChange || [];
  collection.hooks.afterChange.push(hook);

  return collection;
}
